import rightarrowSvg from "@Assets/svg/Dashboard-svgs/right-arrow.svg";
import InstructionSvg from "@Assets/svg/Dashboard-svgs/instruction.svg";
import LeftarrowSvg from "@Assets/svg/Dashboard-svgs/leftarrow.svg";
import PaletteeSvg from "@Assets/svg/MockTest-svgs/Palette.svg";
import { TestTypes } from "@Constants/app.constant";
import SvgIcon from '@Components/icons/SvgIcon';
import { transform } from "typescript";

export const QuestionPaperFooter = ({testType,fullQuestionPaperMode, index, questionsStoreLength, instruction,Qustpalette, onClickPreiousQuestionHandler, setQuestionpaletteHandler,onClickNextQuestionHandler,setFullQuestionPaperModeHandler, setinstructionHadndler,onClickEndTestHandler,submitAnswer,isTestSeries,currentQuestion,isLoading}:any) => {
  const onClickQuestionPalette=()=>{
    if(Qustpalette == true){
      setQuestionpaletteHandler(false);
    }else if(Qustpalette ==false){
      setQuestionpaletteHandler(true);
    }
  }

  if (isLoading) {
    return (
      <div className="question-footer tw-sticky bottom-0">
        <div className="footer-left-card tw-items-center">
          <div className="tw-animate-pulse tw-h-10 tw-w-28 tw-bg-gray-200 tw-rounded-lg"></div>
          <div className="tw-animate-pulse tw-h-10 tw-w-10 tw-bg-gray-200 tw-rounded-lg"></div>
          <div className="tw-animate-pulse tw-h-10 tw-w-28 tw-bg-gray-200 tw-rounded-lg"></div>
        </div>
      </div>
    )
  }
   
  return (
        <div className="question-footer tw-sticky bottom-0">
        {
          <div className="footer-left-card">
            {testType==TestTypes.regular && index ? <a className="prev-qust ia-btn ia-btn-outline-primary" onClick={() => onClickPreiousQuestionHandler()} >
              <SvgIcon name="rightArrow" size={16} style={{transform:'rotate(180deg)'}} /> Previous
            </a> : ''
            }
            <a className="palette-a-card" onClick={() => onClickQuestionPalette()}>
              <img src={PaletteeSvg} alt="palette-img" />
            </a>
            { testType==TestTypes.regular && index < questionsStoreLength - 1 ? <a className="next-qust ia-btn ia-btn-primary" onClick={() => onClickNextQuestionHandler()} >
              Next <SvgIcon name="rightArrow" size={16} /> 
            </a>: ''
}
              { testType==TestTypes.speed && submitAnswer && submitAnswer['SelectedOption'] && submitAnswer['SelectedOption'] !== '' ? <a className="next-qust ia-btn ia-btn-primary" onClick={() => onClickNextQuestionHandler()} >
              Next <SvgIcon name="rightArrow" size={16} />
            </a> : ''
              }
          </div>
        }
        {/* {
          fullQuestionPaperMode &&
          <div className="footer-back-card ">
            <a className="back-qust" onClick={() => setFullQuestionPaperModeHandler(false)} >
              <img src={LeftarrowSvg} alt="rightarrowSvg" />  Back
            </a>

          </div>


        } */}

        {/* <div className="footer-right-card tw-hidden">
          <div className="qust-inst-card">
          {testType==TestTypes.regular ?<a
              href="javascript:void(0)"
              className={`qust-a-btn  ${fullQuestionPaperMode ? 'active-btn' : null}`}
              onClick={() => {
                setFullQuestionPaperModeHandler(true)
              }
              }
            >
              Question Paper
            </a> : ''}  
            <a
              href="javascript:void(0)"
              className={`qust-inst-btn  ${instruction ? 'active-btn' : null}`}
              onClick={() => {
                setinstructionHadndler(true)
              }}
            >
              <img src={InstructionSvg} alt="rightarrowSvg" /> Instructions
            </a>
          </div>

          <div className="tw-w-full" onClick={() => onClickEndTestHandler()} >
            <a href="javascript:void(0)" className="end-test-btn">
              End Test
            </a>
          </div>
        </div> */}
      </div>
)
}
